type NormalizeFunction = (value: string) => string;

/**
 * Function that resolves programCode inconsistencies caused by accents / font variants on different markets.
 * @param programCode ProgramCode
 * @returns Normalized, uppercase (but not necessarily validated) programCode
 */
export const normalizeProgramCode = (programCode: string): string => {
  const normalizeFns: NormalizeFunction[] = [
    // Replace Turkish i with English i, and remove accents
    (value) =>
      value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ı/g, "i")
        .replace(/İ/g, "I")
        .toUpperCase(),
  ];

  return normalizeFns.reduce((result, fn) => fn(result), programCode);
};
